<div class="full-width-height">
  <ion-img [class]="type" [src]="imgSrc" *ngIf="imgSrc else loading"></ion-img>
  <ng-template #loading>
    <ion-spinner class="center vertical-center" *ngIf="spinner"></ion-spinner>
  </ng-template>
</div>
